<template>
  <div class="sections">
    <section
      v-for="(invadobay_section, index) in invadobay_sections.filter(
        (i) => !!i
      )"
      :key="`invadobay:${invadobay_section.preview_type}:${index}`"
      class="section"
    >
      <invadobay-previews :invadobay_section="invadobay_section" />
    </section>
  </div>
</template>

<script>
import { get_config } from "@/utilities/commons";
import { get_invadobays, get_related_invadobays } from "./utilities";
import InvadobayPreviews from "./invadobay-previews.vue";

export default {
  name: "invadobays",
  components: {
    "invadobay-previews": InvadobayPreviews,
  },
  props: {
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      invadobay_sections_data: JSON.stringify([]),
      invadobay_sections_loading: false,
    };
  },
  computed: {
    invadobay_sections: {
      get() {
        try {
          return JSON.parse(this.invadobay_sections_data);
        } catch {
          return [];
        }
      },
      set(value) {
        this.invadobay_sections_data = JSON.stringify(value);
      },
    },
  },
  created() {
    const config =
      (this.options || {}).config ||
      get_config("guiSettings.customizations.invadobays", []);
    if (config.length) {
      this.invadobay_sections = Array.from({ length: config.length });
      this.invadobay_sections_loading = true;
      this.$emit("loading", { is_loading: true });
      const invadobay_promises = config.map(
        (c, i) => () =>
          c.related_to
            ? this.get_related_invadobays(c.related_to)
            : this.get_invadobays(c.invadobays).then((res) => {
                if (res && res.length) {
                  this.invadobay_sections = this.invadobay_sections.map(
                    (elem, j) => (j === i ? { ...c, invadobays: res } : elem)
                  );
                }
              })
      );
      const _this = this;
      Promise.all(invadobay_promises.map((fn) => fn())).finally(() => {
        _this.invadobay_sections_loading = false;
        _this.$emit("loading", { is_loading: false });
      });
    }
  },
  methods: {
    get_invadobays,
    get_related_invadobays,
  },
};
</script>

<style lang="scss" scoped></style>
